module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "admin-acc-up.ab42a27c.svg";